import { AlfatronDspBase } from './util/AlfatronDspBase';
export class AlfatronDspTcp extends AlfatronDspBase {
    constructor(socket, log) {
        super(log);
        this.socket = socket;
        this.log = log;
    }
    send(command) {
        this.socket.send(command);
    }
}
AlfatronDspTcp.emulatorType = 'socketEmulator';
AlfatronDspTcp.key = '-N5CrC5i7GUhmSnsU52s';
